export default __webpack_public_path__ + "static/media/accountTasks.f1c96ef6.svg";